import {
  EVAL_CARD_LAB_STATES,
  type EvalCardLabState,
} from '@/visual-lab/chapters/eval-card/evalCardLabFixture';

/** AI Tutor drawer widths in the student web layout (large, medium, small screens). */
export const EVAL_CARD_LAB_DRAWER_WIDTHS = [360, 320, 300] as const;
export type EvalCardLabDrawerWidth = typeof EVAL_CARD_LAB_DRAWER_WIDTHS[number];

export type EvalCardLabQueryState = {
  state: EvalCardLabState;
  width: EvalCardLabDrawerWidth;
};

function pick<T extends string | number>(raw: string | null, options: readonly T[], fallback: T): T {
  const match = options.find((option) => String(option) === raw);
  return match ?? fallback;
}

/**
 * Reads eval-card lab toggles from `window.location.search` query params.
 */
export function parseEvalCardLabQuery(search: string): EvalCardLabQueryState {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  return {
    state: pick(params.get('state'), EVAL_CARD_LAB_STATES, 'not-ready'),
    width: pick(params.get('width'), EVAL_CARD_LAB_DRAWER_WIDTHS, 360),
  };
}

export function buildEvalCardLabSearch(query: EvalCardLabQueryState): string {
  const params = new URLSearchParams();
  params.set('state', query.state);
  params.set('width', String(query.width));
  return `?${params.toString()}`;
}
